export default __webpack_public_path__ + "static/media/thumbnail_placeholder.08207d35.jpg";